import { render, staticRenderFns } from "./DynamicColumnChart.vue?vue&type=template&id=3f86a912&scoped=true&"
import script from "./DynamicColumnChart.vue?vue&type=script&lang=ts&"
export * from "./DynamicColumnChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86a912",
  null
  
)

export default component.exports